export default __webpack_public_path__ + "static/media/intro2.02d6d14f.png";